import { render, staticRenderFns } from "./FreeShipping.vue?vue&type=template&id=36467504&scoped=true&"
import script from "./FreeShipping.vue?vue&type=script&lang=js&"
export * from "./FreeShipping.vue?vue&type=script&lang=js&"
import style0 from "./FreeShipping.vue?vue&type=style&index=0&id=36467504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36467504",
  null
  
)

export default component.exports